import config from "@/config/config.json";

interface CustomConfig {
    API_URL: string;
    BASE_URL: string;
    GOOGLE_MAPS_API_KEY: string;
    SENTRY_DSN: string;
    GTAG_ID: string;
    CONTROL_URL: string;
    PRODUCTION_READY: boolean;
    MAINTENANCE: boolean;
}

const useConfig = () => {
    return {
        API_URL: config.API_URL,
        BASE_URL: config.BASE_URL,
        GOOGLE_MAPS_API_KEY: config.GOOGLE_MAPS_API_KEY,
        SENTRY_DSN: config.SENTRY_DSN,
        GTAG_ID: config.GTAG_ID,
        CONTROL_URL: config.CONTROL_URL,
        PRODUCTION_READY: config.PRODUCTION_READY,
        MAINTENANCE: config.MAINTENANCE,
    } as CustomConfig
}

export default useConfig;